import React, {useState, createContext} from 'react';
import QUERY_PRODUCTS_BY_IDS from "./Queries/ProductsByIds";
import { useQuery } from '@apollo/client'
import {WooUserProvider} from "./WooUserContext";

export const WooSimpleContext = createContext();

export const WooSimpleProvider = ({productIds, children, acctCustomer}) => {
    const productIdsArray = productIds.split(',');
    const [paged, setPaged] = useState({size: productIdsArray.length}),
        products = useQuery(QUERY_PRODUCTS_BY_IDS,{
            variables: {ids: productIdsArray.map(x => parseInt(x))}
        });
    const store = {
        pagedState: [paged, setPaged],
        acctCustomer,
        products,
    };
    return (
        <WooUserProvider>
            <WooSimpleContext.Provider value={store}>
                {children}
            </WooSimpleContext.Provider>
        </WooUserProvider>
    );
};

